import React, { useMemo, useState } from 'react';
import { View, Image, Text } from 'react-native';
import { useCurrency, useTranslation } from '@oolio-group/localization';
import { UpsellProduct } from '@oolio-group/domain';
import { getStyles } from './ProductCard.styles';
import { useTheme } from '../../../hooks/useTheme';
import Icon from '../../Icon/Icon';

const ProductCard = ({ product }: { product: UpsellProduct }) => {
  const { formatCurrency } = useCurrency();
  const { translate } = useTranslation();

  const { colors } = useTheme();
  const styles = useMemo(() => getStyles(colors), [colors]);

  const [imageError, setImageError] = useState(false);

  const { name, description, price, imageUrl, savingValue } = product;

  return (
    <View style={styles.container}>
      {savingValue !== undefined && savingValue > 0 && (
        <View style={styles.badge}>
          <Text style={styles.badgeText}>
            {translate('modal.savingValues', {
              amount: formatCurrency(savingValue),
            })}
          </Text>
        </View>
      )}
      <View style={styles.image}>
        {imageUrl && !imageError ? (
          <Image
            resizeMode="cover"
            source={{ uri: imageUrl }}
            onError={() => setImageError(true)}
            style={styles.image}
          />
        ) : (
          <Icon size={42} name="crockery" color={colors.disclosure} />
        )}
      </View>
      <View style={styles.text}>
        <Text style={styles.name} numberOfLines={2}>
          {name}
        </Text>
        <Text style={styles.desc} numberOfLines={1}>
          {description}
        </Text>
        <Text style={styles.price}>
          {price ? formatCurrency(price) : 'N/A'}
        </Text>
      </View>
    </View>
  );
};

export default ProductCard;
